const EXTRA_INFO = 'extra_info';

const META = 'meta';

/**
 * This is a clone of the isExtraInfoOrMeta function from
 * 'apps/emergency_data/src/components/JurisdictionView/helpers.js'

 * Get the location's payloadID, requestID, and agent511SessionID.
* @param location - 911 event's location object.
 * @returns Object
 */
const getExtraInfoOrMeta = location => {
  const extraInfoOrMeta = location?.extra_info ? EXTRA_INFO : META;

  if (!location || !location?.[extraInfoOrMeta]) return null;

  return {
    agent511SessionID: location[extraInfoOrMeta]?.agent_511_session_id || null,
    payloadID: location[extraInfoOrMeta]?.payload_id || null,
    requestID: location[extraInfoOrMeta]?.request_id || null,
  };
};

export default getExtraInfoOrMeta;
